import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";
import { TranslationService } from "@obg/ngx.core.content";
import { of } from "rxjs";
import { catchError, filter, map, switchMap, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { NationalityAction } from "./nationality.action";
import { NATIONALITY_CRS_GROUP_KEY } from "./nationality.const";
import { NationalitySelector } from "./nationality.selector";

/**
 * @deprecated [fabric-deprecated] - use fabric ContentService from svc-content instead
 */
@Injectable()
export class NationalityEffect {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentServiceValue.GetAllNationalities)" instead
	 */
	getAll$ = createEffect(() =>
		this.actions$.pipe(
			ofType(NationalityAction.getAll),
			withLatestFrom(this.store.pipe(select(this.selector.getNationalities()))),
			filter(([, nationalities]) => !nationalities?.length),
			switchMap(() =>
				this.translationService.getTranslationGroupByNames([NATIONALITY_CRS_GROUP_KEY]).pipe(
					map((feed) => {
						const regExp = new RegExp(/[Nn]ationalities*.[a-zA-Z]{2,2}/);
						const transformedNationalities = feed
							? Object.keys(feed)
									.filter((key) => typeof feed[key] === "string" && regExp.test(key))
									.map((key) => ({ value: key.split(".")[1].toUpperCase(), name: feed[key] }))
							: undefined;
						return NationalityAction.getAllSuccess(transformedNationalities);
					}),
					catchError((error: AppError) => of(NationalityAction.getAllFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private translationService: TranslationService,
		private selector: NationalitySelector,
		private store: Store<CommonState>
	) {}
}
